import React from "react";
import { ReactComponent as GITHUB } from "../img/social_icons/github_1.svg";

export const GitHubSocial = () => {
  return <GITHUB title="github-social" />;
};
